import backend from "../utils/backend";
import selectn from "selectn";
import * as actionTypes from "../constants/actionTypes";

export var getSections = function getSections() {
  return function (dispatch) {
    dispatch({
      type: actionTypes.GET_SECTIONS
    });

    return backend.request({
      method: "GET",
      url: "/sections/"
    }).then(function (response) {
      dispatch({
        type: actionTypes.GET_SECTIONS_SUCCESS,
        payload: response.data.results
      });
    }).catch(function (err) {
      dispatch({
        type: actionTypes.GET_SECTIONS_ERROR,
        payload: err
      });
    });
  };
};

export var getSection = function getSection(slug) {
  return function (dispatch) {
    dispatch({
      type: actionTypes.GET_SECTION
    });

    return backend.request({
      method: "GET",
      url: "/sections/" + slug + "/"
    }).then(function (response) {
      dispatch({
        type: actionTypes.GET_SECTION_SUCCESS,
        payload: response.data
      });
    }).catch(function (err) {
      dispatch({
        type: actionTypes.GET_SECTION_ERROR,
        payload: err
      });
    });
  };
};

export var setSection = function setSection(section) {
  return function (dispatch) {
    dispatch({
      type: actionTypes.SET_SECTION,
      section: section
    });
  };
};

export var setLastSeen = function setLastSeen(lastSeen) {
  return function (dispatch) {
    dispatch({
      type: actionTypes.SET_LAST_SEEN,
      lastSeen: lastSeen
    });
  };
};

export var getSpecialFeatures = function getSpecialFeatures() {
  return function (dispatch) {
    dispatch({
      type: actionTypes.GET_SPECIAL_FEATURES
    });

    return backend.request({
      method: "GET",
      url: "/special-features/"
    }).then(function (response) {
      dispatch({
        type: actionTypes.GET_SPECIAL_FEATURES_SUCCESS,
        payload: response.data.results
      });
    }).catch(function (err) {
      dispatch({
        type: actionTypes.GET_SPECIAL_FEATURES_ERROR,
        payload: err
      });
    });
  };
};

export var setSectionWithTag = function setSectionWithTag(tag) {
  return function (dispatch) {
    dispatch({
      type: actionTypes.GET_TAG
    });

    return backend.request({
      method: "GET",
      url: "/tag/" + tag + "/"
    }).then(function (response) {
      return dispatch(setSection({ slug: tag, name: selectn("data.name", response) }));
    }).catch(function (err) {
      dispatch({
        type: actionTypes.GET_TAG_ERROR,
        payload: err
      });
    });
  };
};


// WEBPACK FOOTER //
// ./src/actions/navigation.js